import { render, staticRenderFns } from "./BestShopping.vue?vue&type=template&id=7c8ef183&scoped=true"
import script from "./BestShopping.vue?vue&type=script&lang=js"
export * from "./BestShopping.vue?vue&type=script&lang=js"
import style0 from "./BestShopping.vue?vue&type=style&index=0&id=7c8ef183&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8ef183",
  null
  
)

export default component.exports